import { RoundedCloseButton } from "../../Buttons/RoundedCloseButton/Index";
import { ButtonOnlyTitle } from "../../Buttons/ButtonOnlyTitle/Index";
import { useFilter } from "../../../hooks/useFilter";
import { useEffect, useState } from "react";
import { Modal } from "../Default/Index";
import DaySelect from "../../DayPicker";
import { format } from "date-fns";
import { es, ptBR } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import "./styles.css"

type DateModalProps = {
    selectOnlyMonth?: boolean;
    maxDate?: Date;
}

export const DateModal = ({ selectOnlyMonth = false, maxDate = new Date() }: DateModalProps) => {
    const { t, i18n } = useTranslation();
    const dateLocale = i18n.language.startsWith("es") ? es : ptBR;
    const { modalCalendarFilter, setModalCalendarFilter, setFocusLastDay, setRangeDays, selectedDates } = useFilter();
    const [dateBegin, setDateBegin] = useState<string>("");
    const [dateEnd, setDateEnd] = useState<string>("");

    useEffect(() => {
        if (selectedDates?.from) {
            setDateBegin(format(new Date(selectedDates?.from), `dd MMMM y`, { locale: dateLocale }))
        }
        if (selectedDates?.to) {
            setDateEnd(format(new Date(selectedDates?.to), `dd MMMM y`, { locale: dateLocale }))
        }
    }, [selectedDates, i18n.language]);

    return (<>
        <div style={{ zIndex: 910 }}>
            <Modal
                visible={modalCalendarFilter}
                contentStyle={{
                    padding: "60px",
                    width: "433px",
                    height: "auto",
                    borderRadius: 25,
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    gap: 30
                }}
            >
                <header className="success__modal-header">
                    <RoundedCloseButton onClick={() => setModalCalendarFilter(false)} />
                </header>
                <h2 className="dateTitle">{t("dateFilter.title")}</h2>

                <div className="dateFiltersContainer">
                    <DaySelect selectOnlyMonth={selectOnlyMonth} maxDate={maxDate}/>
                    <div className="dateContainer" onClick={() => setFocusLastDay(false)}>
                        <span>{t("dateFilter.start")}</span>
                        <span>{dateBegin}</span>
                    </div>
                    <div className="dateContainer" onClick={() => setFocusLastDay(true)}>
                        <span>{t("dateFilter.end")}</span>
                        <span>{dateEnd}</span>
                    </div>
                </div>

                <footer className="buttons-container">
                    <ButtonOnlyTitle
                        title={t("dateFilter.cancel")}
                        theme="light"
                        onClick={() => {
                            setModalCalendarFilter(false)
                        }}
                    />
                    <ButtonOnlyTitle
                        title={t("dateFilter.apply")}
                        theme="info"
                        onClick={() => {
                            setRangeDays(selectedDates)
                            setModalCalendarFilter(false)
                        }}
                    />
                </footer>
            </Modal>
        </div>
    </>)
}
